
  import { Component, Vue } from 'vue-property-decorator'

  @Component({ name: 'RequiredAsterisk' })
  export default class extends Vue {}
